const styles = muiBaseTheme => ({
  body: {
    background: '#444'
  },
  card: {
    maxWidth: '37.5rem',
    margin: 'auto',
    transition: '0.3s',
    padding: '0.5rem',
    boxShadow: '0 8px 40px -12px rgba(0,0,0,0.3)',
    '&:hover': {
      boxShadow: '0 16px 70px -12.125px rgba(0,0,0,0.3)'
    },
    marginTop: '5rem',
    marginBottom: '1rem'
  },
  content: {
    textAlign: 'left',
    padding: muiBaseTheme.spacing.unit * 3
  },
  divider: {
    margin: `${muiBaseTheme.spacing.unit * 3}px 0`,
    Width: '100%'
  },
  heading: {
    color: '#666666',
    fontSize: '1rem',
    fontWeight: '600',
    letterSpacing: '0.4px',
    lineHeight: '1.3'
  },
  address: {
    textAlign: 'center'
  },
  unsubscribechckbox: {
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', \'sans-serif\'',
    lineHeight: '1.3',
    marginBottom: '0.5rem',
    marginLeft: '1rem'
  },
  chckbox: {
    color: '#FF6800 !important'
  },
  label: {
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', \'sans-serif\'',
    lineHeight: '1.3',
    marginBottom: '0.5rem',
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    textAlign: 'left'
  },
  customlistItem: {
    paddingTop: '0',
    paddingBottom: '0'
  },
  listitemtext: {
    padding: '0'
  },
  listitemcss: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', \'sans-serif\'',
    lineHeight: '1.3'
  },
  footertext: {
    fontWeight: '400',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', \'sans-serif\'',
    color: '#f9f9f9',
    marginTop: '0.25rem'
  },
  unsubscribechckboxcaption: {
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', \'sans-serif\'',
    lineHeight: '1.3',
    marginBottom: '0.5rem',
    marginLeft: '1.5rem'
  },
  link: {
    color: '#3B9BDC',
    fontWeight: '400',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  typographyclr: {
    color: '#f9f9f9',
    marginTop: '5rem',
    marginBottom: '5rem'
  },
  thankyoutext: {
    color: '#666666',
    fontSize: '1rem',
    fontWeight: '600',
    lineHeight: '1.3'
  },
  cardContentText: {
    fontSize: '1rem',
    color: '#666666'
  },
  errorText: {
    color: '#666666',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.3',
    // verticalAlign: 'middle'
  },
  warnText: {
    letterSpacing: '0.4px',
    color: 'orange',
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '2.5',
    marginBottom: '0.5rem',
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    textAlign: 'left'
    // verticalAlign: 'middle'
  },
  checkIcon: {
    fontSize: 30,
    float: 'left',
    marginTop: '0.25rem',
    marginRight: '0.5rem',
    color: 'black',
    borderRadius: '50%',
    padding: '0.15rem',
    // verticalAlign: 'baseline'
  },
  warningIconMultiLine: {
    fontSize: 45,
    float: 'left',
    marginTop: '-0.25rem',
    marginRight: '0.5rem',
    padding: '0.15rem',
    // verticalAlign: 'middle'
  },
  warningIconSingleLine: {
    fontSize: 45,
    float: 'left',
    marginTop: '-0.7rem',
    marginRight: '0.5rem',
    padding: '0.15rem',
    // verticalAlign: 'middle'
  },
  loadingEllipsisWrapper: {
    marginTop: '5rem'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/styles/common.js